// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freelance-agent-info{margin-top:0.5rem;font-size:1rem;line-height:1.4;color:#104182}.freelance-agent-info div{line-height:inherit;color:inherit}\n", ""]);
// Exports
module.exports = exports;
